import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="iot--saved-report-users-filter"
//
// Case-insensitive substring filter over the pre-rendered shareable-users
// checkbox list in the saved-report form (packs/iot/app/views/iot/admin/
// reports/saved_reports/_form.html.erb). Rows carry `data-name` so the
// filter never touches the DOM structure — matching rows stay, non-matching
// rows get `display: none`. Checked-but-filtered-out rows keep their
// `<input type=checkbox>` in the form, so their value still submits when
// the operator hits save (mirrors how the Support ticket-list filter
// behaves).
export default class extends Controller {
  static targets = ["input", "row", "empty", "userCheckbox", "shareToggle"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let visible = 0
    this.rowTargets.forEach((row) => {
      const name = (row.dataset.name || "").toLowerCase()
      const match = query === "" || name.includes(query)
      row.style.display = match ? "" : "none"
      if (match) visible += 1
    })
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visible > 0)
    }
  }

  // "Share with my team" toggle → check every user in the list when it
  // goes on, uncheck every user when it goes off. This is a select-all
  // convenience shortcut — the operator can still fine-tune individual
  // users after toggling.
  syncFromShareToggle() {
    if (!this.hasShareToggleTarget || !this.hasUserCheckboxTarget) return
    const checked = this.shareToggleTarget.checked
    this.userCheckboxTargets.forEach((cb) => {
      cb.checked = checked
    })
  }
}
